import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import WhatIsPcch from "@/pages/WhatIsPcch";
import Happening from "@/pages/Happening";
import Membership from "@/pages/Membership";
import GetInvolved from "@/pages/GetInvolved";
import Visit from "@/pages/Visit";
import Transparency from "@/pages/Transparency";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import StudioManage from "@/pages/StudioManage";
import WorkRoom from "@/pages/WorkRoom";
import ResetPassword from "@/pages/ResetPassword";
import Activate from "@/pages/Activate";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Shell = () => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <>
            <ScrollToTop />
            {!isAdmin && <Nav />}
            <main id="main-content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/what-is-pcch" element={<WhatIsPcch />} />
                    <Route path="/whats-happening" element={<Happening />} />
                    <Route path="/membership" element={<Membership />} />
                    <Route path="/get-involved" element={<GetInvolved />} />
                    <Route path="/visit" element={<Visit />} />
                    <Route path="/transparency" element={<Transparency />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/host-collaborate" element={<Navigate to="/get-involved" replace />} />
                    <Route path="/rent" element={<Navigate to="/get-involved" replace />} />
                    <Route path="/diary" element={<Navigate to="/" replace />} />
                    <Route path="/work-room" element={<WorkRoom />} />
                    <Route path="/work-room/manage/:token" element={<StudioManage />} />
                    <Route path="/studio" element={<Navigate to="/work-room" replace />} />
                    <Route path="/studio/manage/:token" element={<StudioManage />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/activate" element={<Activate />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </main>
            {!isAdmin && <Footer />}
        </>
    );
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
                <AuthProvider>
                    <ContentProvider>
                        <Shell />
                        <Toaster position="top-center" />
                    </ContentProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
